<template>
	<div class="brick-footer">
		<div class="brick-footer__overlap" v-if="tasks">
			<Progress
				:tasks="tasks">
			</Progress>
		</div>
	</div>
</template>

<script>
import Progress from '@/components/Progress'
export default {
	components: {
		Progress
	},
	props: {
		tasks: Array
	}
}
</script>

<style lang="scss" scoped>
.brick-footer {
	@extend %brick__footer;
	width:100%;
	&__overlap {
		width: calc(100% - 2 * 20px);
		transform: translateY(-50%);
		top: 0;
		position: absolute;
		border: white solid $progress-bar-border-width;
		border-radius: $spacing-2;
		& .progress {
			width: 100%;
		}
	}
}
</style>
